// label: value
const activeStateTypes = {
  active: 'active',
  archived: 'inactive',
}

export default activeStateTypes
